import React, { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import SpecificationsContentContainer from './SpecificationsContentContainer';
import specificationsModalStyles from './specificationsModalStyles';
import ModalWithHeader from '../../../../../../common/components/presentation/ModalWithHeader';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface ISpecificationsModal {
  isSpecFeaturesModalOpen: boolean;
  toggleSpecFeaturesModal: (val: boolean) => void;
  selectedVariantId: string;
}

const SpecificationsModal: FunctionComponent<ISpecificationsModal> = ({
  isSpecFeaturesModalOpen,
  toggleSpecFeaturesModal,
  selectedVariantId,
}) => {
  const styles = specificationsModalStyles();

  return (
    <ModalWithHeader
      open={isSpecFeaturesModalOpen}
      toggleModal={toggleSpecFeaturesModal}
      title={
        <Typography className={styles.title} data-test="customise:specifications_modal_title">
          <Translation id="trans__configurator__customise_page_variant_section__specs_modal_title" />
        </Typography>
      }
    >
      <SpecificationsContentContainer selectedVariantId={selectedVariantId} />
    </ModalWithHeader>
  );
};

export default SpecificationsModal;
